import emergencyExitImage from '../../../assets/images/image-complexity/Low/Emergency Exit.png'
import atmImage from '../../../assets/images/image-complexity/Low/ATM.png'
import hallwayImage from '../../../assets/images/image-complexity/Low/Hallway.png'

import lowActivityPerimeterImage from '../../../assets/images/image-complexity/Medium Low/Low activity perimeter.png'
import receptionImage from '../../../assets/images/image-complexity/Medium Low/Reception.png'
import noneBusyCarparkImage from '../../../assets/images/image-complexity/Medium Low/None busy carpark.png'

import noneBusyIntersectionImage from '../../../assets/images/image-complexity/Medium/None busy intersection.png'
import retailStoreImage from '../../../assets/images/image-complexity/Medium/Retails store.png'
import noneBusyPedestrianStreetImage from '../../../assets/images/image-complexity/Medium/None busy pedestrian street.png'

import cashierCheckoutImage from '../../../assets/images/image-complexity/Medium High/Cashier checkout.png'
import mediumBusyIntersectionImage from '../../../assets/images/image-complexity/Medium High/Medium busy intersection.png'
import busyMarketplaceImage from '../../../assets/images/image-complexity/Medium High/Busy marketplace.png'

import busyHighwayImage from '../../../assets/images/image-complexity/High/Busy Highway.png'
import busyWalkingStreetImage from '../../../assets/images/image-complexity/High/Busy walking street.png'
import busyTrainStationImage from '../../../assets/images/image-complexity/High/Busy Train station.png'

export type ComplexityLevel = 'Low' | 'Medium Low' | 'Medium' | 'Medium High' | 'High'

export type ImageComplexityScenario = {
  id: ImageComplexityScenarioId
  name: string
  complexity: ComplexityLevel
  imageSrc: string
  alt: string
}

export type ImageComplexityScenarioId =
  | 'emergency-exit'
  | 'atm'
  | 'hallway'
  | 'no-activity-perimeter'
  | 'reception'
  | 'no-busy-car-park'
  | 'none-busy-intersection'
  | 'retail-store'
  | 'none-busy-pedestrian-street'
  | 'cashier-checkout'
  | 'medium-busy-intersection'
  | 'busy-marketplace'
  | 'busy-highway'
  | 'busy-walking-street'
  | 'busy-train-station'

export const imageComplexityScenarios: ImageComplexityScenario[] = [
  {
    id: 'emergency-exit',
    name: 'Emergency Exit',
    complexity: 'Low',
    imageSrc: emergencyExitImage,
    alt: 'Emergency exit in a quiet indoor environment'
  },
  {
    id: 'atm',
    name: 'ATM',
    complexity: 'Low',
    imageSrc: atmImage,
    alt: 'ATM in a mostly empty indoor area'
  },
  {
    id: 'hallway',
    name: 'Hallway',
    complexity: 'Low',
    imageSrc: hallwayImage,
    alt: 'Long hallway with low activity'
  },
  {
    id: 'no-activity-perimeter',
    name: 'No Activity Perimeter',
    complexity: 'Medium Low',
    imageSrc: lowActivityPerimeterImage,
    alt: 'Outdoor perimeter with little movement'
  },
  {
    id: 'reception',
    name: 'Reception',
    complexity: 'Medium Low',
    imageSrc: receptionImage,
    alt: 'Reception desk area with modest activity'
  },
  {
    id: 'no-busy-car-park',
    name: 'No Busy Car Park',
    complexity: 'Medium Low',
    imageSrc: noneBusyCarparkImage,
    alt: 'Car park with sparse traffic'
  },
  {
    id: 'none-busy-intersection',
    name: 'None Busy Intersection',
    complexity: 'Medium',
    imageSrc: noneBusyIntersectionImage,
    alt: 'Intersection with moderate vehicle and pedestrian activity'
  },
  {
    id: 'retail-store',
    name: 'Retail Store',
    complexity: 'Medium',
    imageSrc: retailStoreImage,
    alt: 'Retail store interior with moderate movement'
  },
  {
    id: 'none-busy-pedestrian-street',
    name: 'None Busy Pedestrian Street',
    complexity: 'Medium',
    imageSrc: noneBusyPedestrianStreetImage,
    alt: 'Pedestrian street with moderate foot traffic'
  },
  {
    id: 'cashier-checkout',
    name: 'Cashier Checkout',
    complexity: 'Medium High',
    imageSrc: cashierCheckoutImage,
    alt: 'Checkout area with frequent movement'
  },
  {
    id: 'medium-busy-intersection',
    name: 'Medium Busy Intersection',
    complexity: 'Medium High',
    imageSrc: mediumBusyIntersectionImage,
    alt: 'Intersection with heavier traffic and movement'
  },
  {
    id: 'busy-marketplace',
    name: 'Busy Marketplace',
    complexity: 'Medium High',
    imageSrc: busyMarketplaceImage,
    alt: 'Outdoor market with many moving people'
  },
  {
    id: 'busy-highway',
    name: 'Busy Highway',
    complexity: 'High',
    imageSrc: busyHighwayImage,
    alt: 'Highway scene with dense vehicle movement'
  },
  {
    id: 'busy-walking-street',
    name: 'Busy Walking Street',
    complexity: 'High',
    imageSrc: busyWalkingStreetImage,
    alt: 'Crowded street with heavy pedestrian flow'
  },
  {
    id: 'busy-train-station',
    name: 'Busy Train Station',
    complexity: 'High',
    imageSrc: busyTrainStationImage,
    alt: 'Busy station platform with dense crowd movement'
  }
]

export const imageComplexityScenarioToLevelMap: Record<ImageComplexityScenarioId, ComplexityLevel> = {
  'emergency-exit': 'Low',
  atm: 'Low',
  hallway: 'Low',
  'no-activity-perimeter': 'Medium Low',
  reception: 'Medium Low',
  'no-busy-car-park': 'Medium Low',
  'none-busy-intersection': 'Medium',
  'retail-store': 'Medium',
  'none-busy-pedestrian-street': 'Medium',
  'cashier-checkout': 'Medium High',
  'medium-busy-intersection': 'Medium High',
  'busy-marketplace': 'Medium High',
  'busy-highway': 'High',
  'busy-walking-street': 'High',
  'busy-train-station': 'High'
}

export const getComplexityLevelForScenario = (scenarioId: string): ComplexityLevel | null => {
  return imageComplexityScenarioToLevelMap[scenarioId as ImageComplexityScenarioId] ?? null
}
